<template>
  <div
    :id="data.id"
    v-lazy-background="getAssetUrl(data.image)"
    class="flex h-[32rem] justify-center bg-cover bg-bottom pt-14 text-slate md:h-[54.75rem] md:pt-[4.5rem]"
  >
    <div class="relative flex flex-col justify-between overflow-hidden">
      <div class="container text-center">
        <UiSectionTitle
          v-if="data.title"
          :title="data.title"
          tag="h1"
          class="title mb-2 whitespace-pre-line text-3xl uppercase leading-none md:text-[3.5rem]"
        />

        <div
          v-if="data.text"
          class="mb-6 font-segoe text-md leading-[1.813rem]"
        >
          <span class="whitespace-pre-line" v-html="data.text" />
        </div>

        <div v-if="data.button && data.button.isVisible" class="mb-6">
          <UiButton
            size="md"
            :to="data.button.link"
            :target="data.button.target"
          >
            <span v-html="data.button.text" />
          </UiButton>
        </div>
      </div>

      <div
        v-if="data.markers && data.markers.length"
        class="relative mx-auto mt-auto max-w-full"
      >
        <CdnImg
          v-if="data.markersBoard && data.markersBoard.image"
          :src="handleImageSrc(data.markersBoard.image)"
          :alt="handleImageAlt(data.markersBoard.image)"
          :style="markersBoardImageStyles"
          loading="lazy"
          :width="1300"
          :height="535"
          class="max-w-full"
        />

        <div class="absolute inset-0">
          <UiMarkerPoint
            v-for="(marker, mi) in data.markers"
            :key="mi"
            :marker="marker"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { CdnImg } from '@webplatform/cdn-image';
import { useBreakpoint, useMediaAsset } from '~/composables';
import { handleImageSrc, handleImageAlt } from '~/helpers';

interface Props {
  data?: any;
}

const props = withDefaults(defineProps<Props>(), {
  data: () => ({}),
});

const { getAssetUrl } = useMediaAsset();
const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');

const markersBoardImageStyles = computed(() => {
  const styles = props.data.markersBoard?.styles;
  return isDesktop.value ? styles?.desktop : styles?.mobile;
});
</script>
